import React from "react";
import { Row, Col, Input, Label } from "reactstrap";
import axios from "axios";

/**
 * Datos de la Orden de Produccion (PDF) que se capturan por orden de maquila:
 * modelo de referencia, descripcion, marca, tela, lavado, departamento y las firmas. Se prellenan con el catalogo
 * del articulo y con el usuario; lo capturado aqui es lo que sale en el PDF.
 * Se usa en CortesCreate, en la orden desde Nuevo Pedido y al editar en ListadoCortes.
 */
export const CAMPOS_DATOS_ORDEN = [
  { campo: "modelo", etiqueta: "Modelo de ref. (cliente)" },
  { campo: "descripcion", etiqueta: "Descripción" },
  { campo: "marca", etiqueta: "Marca" },
  { campo: "tela", etiqueta: "Tela" },
  { campo: "lavado", etiqueta: "Lavado" },
  { campo: "departamento", etiqueta: "Departamento" },
  { campo: "elaboradoPor", etiqueta: "Elaborado por" },
  { campo: "autorizadoPor", etiqueta: "Autorizado" },
  { campo: "diseno", etiqueta: "Diseño" },
];

export const datosOrdenVacios = () => Object.fromEntries(CAMPOS_DATOS_ORDEN.map((c) => [c.campo, ""]));

const sinNA = (t) => (t && !/^N\/?A$/i.test(String(t).trim()) ? String(t) : "");

/**
 * Prellenado desde el catalogo del articulo (marca y departamento ya con nombre).
 * `modelo` es el modelo del cliente capturado en el pedido, que manda sobre el del catalogo.
 */
export async function datosOrdenDeArticulo(idArticulo, elaboradoPor = "", modelo = "") {
  const base = { ...datosOrdenVacios(), elaboradoPor, modelo: sinNA(modelo) };
  if (!idArticulo) return base;
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_URL_ARTICULOS}/${idArticulo}`, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    });
    const a = data || {};
    const primero = (x) => (Array.isArray(x) ? x[0] : x);
    let departamento = primero(a.departamentos);
    if (departamento && !departamento.name && process.env.REACT_APP_URL_DEPARTAMENTOS) {
      departamento = await axios
        .get(`${process.env.REACT_APP_URL_DEPARTAMENTOS}/${departamento}`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        })
        .then((r) => r.data)
        .catch(() => null);
    }
    return {
      ...base,
      modelo: base.modelo || sinNA(a.codigoCliente),
      descripcion: sinNA(a.descripcion),
      marca: sinNA(primero(a.marcas)?.name),
      tela: sinNA(a.tela),
      lavado: sinNA(a.lavado),
      departamento: sinNA(departamento && departamento.name),
    };
  } catch (e) {
    return base;
  }
}

function DatosOrdenProduccion({ valor, onChange }) {
  const v = valor || datosOrdenVacios();
  return (
    <Row>
      {CAMPOS_DATOS_ORDEN.map((c) => (
        <Col md={3} key={c.campo} className="mb-2">
          <Label>{c.etiqueta}</Label>
          <Input value={v[c.campo] || ""} onChange={(e) => onChange({ ...v, [c.campo]: e.target.value })} />
        </Col>
      ))}
    </Row>
  );
}

export default DatosOrdenProduccion;
